import React from "../../_snowpack/pkg/react.js";
import {useTranslation} from "../../_snowpack/pkg/react-i18next.js";
import {
  DataListItemRow,
  DataListControl,
  DataListDragButton,
  DataListItemCells,
  DataListCell,
  DataListItem,
  DataListToggle,
  Text,
  TextVariants,
  Button
} from "../../_snowpack/pkg/@patternfly/react-core.js";
import {TrashIcon} from "../../_snowpack/pkg/@patternfly/react-icons.js";
import {FlowTitle} from "./FlowTitle.js";
import {FlowRequirementDropdown} from "./FlowRequirementDropdown.js";
import {ExecutionConfigModal} from "./ExecutionConfigModal.js";
import {EditFlowDropdown} from "./EditFlowDropdown.js";
import "./flow-row.css";
export const FlowRow = ({
  builtIn,
  execution,
  onRowClick,
  onRowChange,
  onAddExecution,
  onAddFlow,
  onDelete
}) => {
  const {t} = useTranslation("authentication");
  const hasSubList = !!execution.executionList?.length;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(DataListItem, {
    className: "keycloak__authentication__flow-item",
    id: execution.id,
    isExpanded: !execution.isCollapsed
  }, /* @__PURE__ */ React.createElement(DataListItemRow, {
    className: "keycloak__authentication__flow-row",
    "aria-level": execution.level
  }, /* @__PURE__ */ React.createElement(DataListControl, null, /* @__PURE__ */ React.createElement(DataListDragButton, {
    "aria-labelledby": execution.displayName,
    "aria-describedby": t("common-help:dragHelp")
  })), hasSubList && /* @__PURE__ */ React.createElement(DataListToggle, {
    onClick: () => onRowClick(execution),
    isExpanded: !execution.isCollapsed,
    id: `toggle1-${execution.id}`,
    "aria-controls": `expand-${execution.id}`
  }), /* @__PURE__ */ React.createElement(DataListItemCells, {
    dataListCells: [
      /* @__PURE__ */ React.createElement(DataListCell, {
        key: `${execution.id}-name`
      }, !execution.authenticationFlow && /* @__PURE__ */ React.createElement(FlowTitle, {
        key: execution.id,
        title: execution.displayName
      }), execution.authenticationFlow && /* @__PURE__ */ React.createElement(React.Fragment, null, execution.displayName, " ", /* @__PURE__ */ React.createElement("br", null), " ", /* @__PURE__ */ React.createElement(Text, {
        component: TextVariants.small
      }, execution.description))),
      /* @__PURE__ */ React.createElement(DataListCell, {
        key: `${execution.id}-requirement`
      }, /* @__PURE__ */ React.createElement(FlowRequirementDropdown, {
        flow: execution,
        onChange: onRowChange
      })),
      /* @__PURE__ */ React.createElement(DataListCell, {
        key: `${execution.id}-config`
      }, execution.configurable && /* @__PURE__ */ React.createElement(ExecutionConfigModal, {
        execution
      }), execution.authenticationFlow && !builtIn && /* @__PURE__ */ React.createElement(EditFlowDropdown, {
        execution,
        onAddExecution,
        onAddFlow
      }), !builtIn && /* @__PURE__ */ React.createElement(Button, {
        variant: "plain",
        "aria-label": t("common:delete"),
        onClick: onDelete
      }, /* @__PURE__ */ React.createElement(TrashIcon, null)))
    ]
  }))), !execution.isCollapsed && hasSubList && execution.executionList?.map((execution2) => /* @__PURE__ */ React.createElement(FlowRow, {
    builtIn,
    key: execution2.id,
    execution: execution2,
    onRowClick,
    onRowChange,
    onAddExecution,
    onAddFlow,
    onDelete
  })));
};
